/**
 * useAuth — thin wrapper around useAuthContext().
 *
 * The actual query (trpc.auth.me) lives in AuthProvider (AuthContext.tsx).
 * This hook just re-exports the context value so existing code that calls
 * useAuth() continues to work without modification.
 *
 * DO NOT add trpc.auth.me.useQuery() here — that would create a second
 * query instance and cause the insertBefore DOM corruption error.
 */
import { useAuthContext } from "@/contexts/AuthContext";

export function useAuth() {
  const ctx = useAuthContext();
  return {
    user: ctx.user,
    loading: ctx.loading,
    isAuthenticated: ctx.isAuthenticated,
    logout: ctx.logout,
    refresh: ctx.refresh,
  };
}
